import type { FigureResponse } from "@patent-studio/api-types";
import type { Tone } from "@/components/ui/tone";

/** How a projected status reads, and the tone it reads in. */
interface StatusTag {
  label: string;
  tone: Tone;
}

/**
 * The tag for a served status, in the design's words and tones: a figure
 * nobody has started on is red, one part-way through amber.
 *
 * A total record rather than a switch with a default: a status added to the
 * projection must be given wording here, and the type stops this compiling
 * until it is.
 */
const TAGS: Record<FigureResponse["define_status"], StatusTag> = {
  complete: { label: "Done", tone: "success" },
  incomplete: { label: "Incomplete", tone: "warning" },
  not_started: { label: "Not started", tone: "destructive" },
};

export function statusTag(status: FigureResponse["define_status"]): StatusTag {
  return TAGS[status];
}
